import React from "react";
import { IMAGES } from "../utils/images";
import "../Styles/signup.css";
import { Link } from "react-router-dom";
import SignUpForm from "./SignUpComponents/SignUpForm";

const SignUp = () => {
  return (
    <div className="outlet-render">
    <div className="signup-main-container">
      <SignUpForm/>
        <img src={IMAGES.SIGNIN_MAIN} alt="signup image"  className="signup-right-container"/>
  
    </div>
    </div>
  );
};

export default SignUp;
